import { Component, OnInit } from '@angular/core';
import { Globals } from "../../_models/globals";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-admin-vamaship-create',
  templateUrl: './admin-vamaship-create.component.html',
  styleUrls: ['./admin-vamaship-create.component.scss'],
})
export class AdminVamashipCreateComponent implements OnInit {

  carrierName: string;
  carrierNameError: string;
  authorization: string;
  authorizationError: string;

  constructor(private alertService: AlertService, private g: Globals, private http: HttpClient, private router: Router, private route: ActivatedRoute) {

  }



  carrierNameBlur() {
    this.carrierNameError = "";
    if (!this.carrierName) {
      this.carrierNameError = 'Please enter carrier name';
    }
  }

  authorizationBlur() {
    this.authorizationError = "";
    if (!this.authorization) {
      this.authorizationError = 'Please enter authorization';
    }
  }


  ngOnInit() { }

  verify() {

    this.g.loaderDisplay = "display";
    this.carrierNameError = "";
    this.authorizationError = "";

    if (!this.carrierName) {
      this.carrierNameError = 'Please enter carrier name';
    }
    if (!this.authorization) {
      this.authorizationError = 'Please enter authorization';
    }
    if (this.carrierNameError != "" || this.authorizationError != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    // api body
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/verifyAndSaveCarrierCredentials', {
      "connectionName": this.carrierName,
      "carrierCode": "VS",
      "organizationId": 1,
      "authorization": this.authorization
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Vamaship', 'Create Successfully');
          this.router.navigate(['/admin/adminCarriers']);
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          console.log(err);
        })
  }

}
